<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  watch: {
    $route(to) {
      if (to.fullPath != "/") {
        this.axios
          .get(this.$store.state.serve + "shop/is_login", {
            params: {
              token: this.$cookies.get("shop_token")
            }
          })
          .then(res => {
            if (res.data.status == "success") {
              // next();
            } else {
              this.$confirm("您的登录信息已过期,需重新登录", "登录提示", {
                confirmButtonText: "去登陆",
                cancelButtonText: "留在此页",
                type: "warning"
              })
                .then(() => {
                  this.$router.push("/");
                  // this.$message({
                  //   type: "success",
                  //   message: "删除成功!"
                  // });
                })
                .catch(() => {
                  // this.$message({
                  //   type: "info",
                  //   message: "已取消登录"
                  // });
                });
            }
          });
      }
    }
  }
};
</script>
<style lang="scss">
@import url("./assets/reset.css");
</style>
